// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NgrVlXBya90ULhjY9bIx{flex-direction:column;display:flex}.BbAYTl7atYo22txuZ5LE{cursor:pointer;margin-bottom:8px}.BbAYTl7atYo22txuZ5LE:last-of-type{margin-bottom:0}.q_fv6Fp8UoUctjAOwiIh{margin-right:4px;font-size:16px}.q_fv6Fp8UoUctjAOwiIh>div{color:var(--content-primary-tertiary-inverted)}.UgTOWNr94FULQaYlWh8V{color:var(--content-primary-tertiary-inverted);margin-right:4px;font-size:13px;font-weight:400}.OOThLXAAPwwKXQ88C6v8{color:var(--content-primary-primary-inverted);font-size:13px;font-weight:400}.Fy70yt6bLjIiHs9PP8fJ{align-items:center;display:flex}.s4DojEdJ49Urrglv1MbK{color:var(--content-primary-tertiary-inverted);background:var(--background-primary-inverted-disabled);border-radius:4px;margin:8px 0 5px 20px;padding:6px;font-size:12px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NgrVlXBya90ULhjY9bIx`,
	"item": `BbAYTl7atYo22txuZ5LE`,
	"item__icon": `q_fv6Fp8UoUctjAOwiIh`,
	"itemIcon": `q_fv6Fp8UoUctjAOwiIh`,
	"item__title": `UgTOWNr94FULQaYlWh8V`,
	"itemTitle": `UgTOWNr94FULQaYlWh8V`,
	"item__total": `OOThLXAAPwwKXQ88C6v8`,
	"itemTotal": `OOThLXAAPwwKXQ88C6v8`,
	"itemWrap": `Fy70yt6bLjIiHs9PP8fJ`,
	"dropdown": `s4DojEdJ49Urrglv1MbK`
};
export default ___CSS_LOADER_EXPORT___;
